import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgForOf, NgIf, NgOptimizedImage } from '@angular/common';
import { TuiButtonModule, TuiModeModule } from '@taiga-ui/core';
import { TuiCarouselModule, TuiPaginationModule } from '@taiga-ui/kit';

@Component({
    selector: 'us-banners-v2',
    standalone: true,
    imports: [TuiCarouselModule, NgIf, NgForOf, NgOptimizedImage, TuiButtonModule, TuiPaginationModule, TuiModeModule],
    templateUrl: './banners-v2.component.html',
    styleUrls: ['./banners-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannersV2Component {
    @Input() banners: Array<string> = [];
    @Input() width = 720;
    @Input() height = 200;
    @Input() aspectRatio = 'aspect-[3.6/1]';

    readonly duration = 5000;
    index = 0;

    constructor() {}

    navigate(delta: number): void {
        const index = (this.index + delta) % this.banners.length;
        this.index = index < 0 ? this.banners.length - 1 : index;
    }
}
